import { render, staticRenderFns } from "./EventOverviewBadge.vue?vue&type=template&id=a45f9c5e"
import script from "./EventOverviewBadge.vue?vue&type=script&lang=js"
export * from "./EventOverviewBadge.vue?vue&type=script&lang=js"
import style0 from "./EventOverviewBadge.vue?vue&type=style&index=0&id=a45f9c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports